import { createContext } from 'react';

export const PdfContext = createContext<{ isPdf: boolean, pdfIds?: number[], setIsPdfReady?: (ready: boolean) => void }>({ isPdf: false });
